module.exports = __webpack_public_path__ + "static/media/preview4-large.a6120fa6.jpg";